import {useCallback, useState} from "react";
import {HttpMethod, initFetch} from "../utils/fetcher";

const useDocket = () => {

  const [data, setData] = useState({
    title: '',
    number: '',
    payments: []
  });

  const [loading,setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Fonction pour créer un nouveau bordereau
  const createDocket = useCallback(async (docket) => {
    setData(null);
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const { url, params} = initFetch('bordereaux', HttpMethod.POST);
      const response = await fetch(url, {
        ...params,
        body: JSON.stringify(docket)
      });

      /*if (!response.ok) {
        throw new Error(`Erreur HTTP returned ${response.status}`);
      }*/

      const result = await response.json();

      if (!result.status) {
        throw new Error(`Erreur returned ${response.message}`);
      }

      setData(result.docket);
      setSuccess(true);

    } catch (e) {
      setError(e.message);
      setLoading(false);
      throw e;
    }
    finally {
      setLoading(false);
    }
  }, []);


  const listDockets = useCallback(async (year) => {

    setLoading(true);
    setError(null);

    try {
      const {url, params} = initFetch(`bordereaux?year=${year}`, HttpMethod.GET);
      const response = await fetch(url, params);

      if (!response.ok) {
        throw new Error(`Erreur HTTP returned ${response.status}`);
      }

      const result = await response.json();

      if (!result.status) {
        throw new Error(`Erreur returned ${response.message}`);
      }

      setData({
        dockets: result.dockets,
        number: result.number,
        years: result.years,
      });


    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  },[]);


  return {
    // Données
    data,

    // États
    loading,
    error,
    success,

    // Actions
    createDocket,
    listDockets
  };
};

export default useDocket;